////////////*** HELPER FUNCTION ***////////////

function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

function getViewportHeight() {
  return Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );
}

function getScrollTop() {
  return window.pageYOffset !== undefined
    ? window.pageYOffset
    : (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;
}

function isInViewport(element) {
  if (element === null) return false; // Ensure the element exists before proceeding

  var rect = element.getBoundingClientRect();
  var elementTop = rect.top + getScrollTop();
  var elementBottom = elementTop + rect.height;
  var viewportTop = getScrollTop();
  var viewportBottom = viewportTop + getViewportHeight();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

////////////*** END HELPER FUNCTION ***////////////

// How to Use & Ingredients

window.addEventListener("scroll", checkBundleAccordionViewport, { passive: true });
// document.addEventListener("DOMContentLoaded", checkBundleAccordionViewport);

function checkBundleAccordionViewport() {
  if (window.runExperiment100472986) {
    window.removeEventListener("scroll", checkBundleAccordionViewport);
    return;
  }
  const ingredientList = document.querySelector(".ingredient-list");
  const productFaq = document.querySelector(".product-faq");
  const descriptionToggle = document.querySelector(".toggle-panel");
  const newVerifiedCustomers = document.querySelector(
    ".new-verified-customers"
  );
  const faqSection = document.querySelector(
    ".intro--normal.section-spacing--top"
  );

  const hasElementInViewport =
    (ingredientList && isInViewport(ingredientList)) ||
    (productFaq && isInViewport(productFaq)) ||
    (descriptionToggle && isInViewport(descriptionToggle)) ||
    (newVerifiedCustomers && isInViewport(newVerifiedCustomers)) ||
    (faqSection && isInViewport(faqSection));

  if (!window.runExperiment100472986 && hasElementInViewport) {
    window.runExperiment100472986 = 1;
    window.removeEventListener("scroll", checkBundleAccordionViewport);
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100472986"]);
    console.log(
      "Convert - 100472986 - Her Fantasy Bundle - How to Use & Ingredients - Experiment Activated"
    );
  }
}

// How to Use & Ingredients

window.addEventListener("scroll", checkDescriptionAccordionViewport, { passive: true });
document.addEventListener(
  "DOMContentLoaded",
  checkDescriptionAccordionViewport
);

function checkDescriptionAccordionViewport() {
  if (window.runExperiment100477301) {
    window.removeEventListener("scroll", checkDescriptionAccordionViewport);
    return;
  }
  const descriptionTop = document.querySelector(".product-main-description");
  const descriptionBottom = document.querySelector(".description-accordion");

  const hasElementInViewport =
    (descriptionTop && isInViewport(descriptionTop)) ||
    (descriptionBottom && isInViewport(descriptionBottom));

  if (!window.runExperiment100477301 && hasElementInViewport) {
    window.runExperiment100477301 = 1;
    window.removeEventListener("scroll", checkDescriptionAccordionViewport);
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100477301"]);
    console.log(
      "Convert - 100477301 - Renew Her Oil - Description Accordion - Experiment Activated"
    );
  }
}


// Animated Reviews Homepage

window.addEventListener("scroll", reviewsViewport, { passive: true });
document.addEventListener(
  "DOMContentLoaded",
  reviewsViewport
);

function reviewsViewport() {
  if (window.runExperiment100495453) {
    window.removeEventListener("scroll", reviewsViewport);
    return;
  }
  const reviews = document.querySelector(".new-verified-customers--ratingstats");

  const hasElementInViewport =
    (reviews && isInViewport(reviews))

  if (!window.runExperiment100495453 && hasElementInViewport) {
    window.runExperiment100495453 = 1;
    window.removeEventListener("scroll", reviewsViewport);
    window._conv_q = window._conv_q || [];
    window._conv_q.push(["executeExperiment", "100495453"]);
    console.log(
      "Convert - 100495453 - Homepage | Animated Reviews - Experiment Activated"
    );
  }
}

// A/B Test - Reviews menu
window.addEventListener("DOMContentLoaded", function() {
  const headerHamburger = document.querySelector(".header-hamburger")
  if (headerHamburger) {
    headerHamburger.addEventListener('click', function() {
      if (!window.runExperimentReviewsNav) {
        window.runExperimentReviewsNav = 1;
        window._conv_q = window._conv_q || [];
        window._conv_q.push(["executeExperiment", "1004114842"]);
        console.log(
          "Convert - 1004114842 - Mobile Nav | Reviews - Experiment Activated"
        );
      }
    });
  }  
  const reviewsLink = document.querySelector(".link-reviews-results")
  if (reviewsLink) {
    reviewsLink.addEventListener('click', function() {
      window._conv_q = window._conv_q || [];  
      _conv_q.push(["triggerConversion", "100477914"]); 
      console.log("Trigger Conversion")
    })
  }
});



// A/B Test - Quiz
// Function to handle clicks on quiz-related links
function handleQuizLinkClick(event) {
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100478815"]);
}
// Attach event listener to all matching <a> elements
document.querySelectorAll('a[href^="#quiz-"]').forEach(link => {
    link.addEventListener("click", handleQuizLinkClick);
});
